<template>
  <v-row align="center" justify="center">
    <v-col cols="6">
      <v-card class="text-xs-center">
        <v-card-title>
          <h2
            class="text-xs-center font-weight-bold"
            v-text="'You are logging out from the application!'"
          ></h2>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p v-text="'Are you sure you want to logout?'"></p>
          <v-divider class="my-4"></v-divider>
          <v-btn
            color="indigo darken-4"
            class="white--text text-capitalize mr-2"
            @click="logout"
          >
            Yes Log Me Out
          </v-btn>
          <v-btn
            color="indigo darken-4"
            class="white--text text-capitalize"
            @click="$router.push('/')"
          >
            Cancel
          </v-btn>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  mounted() {
    document.title = `${this.$rhrCoreShellOptions.name} | Logout`;
  },
  beforeDestroy() {
    document.title = `${this.$rhrCoreShellOptions.name}`;
  }
};
</script>
